// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { PathStatusIdEnum, ProjectStatusIdEnum } from 'config/enums'
import isEBandPath from 'helpers/isEBandPath'

// NOTE - this does not check if user is also the Project create user
// backend validates this on path create so the below does not check it.

// determine if the user can edit this path details form.
// if the path is In Progress, then the user must be the create user to edit.
// if the path is NOT In Progress, then they must be a database user to edit.

const canUserEditPathDetails = (pathDataNew, createUserId) => (dispatch, getState) => {
  const {
    projectSummary,
    user,
  } = getState()

  const withinProjectSummary = projectSummary.get('projectId') !== null
  const projectStatusId = projectSummary.getIn(['projectStatus', 'projectStatusId'])

  const projectIsInProgress = projectStatusId === ProjectStatusIdEnum.IN_PROGRESS
  const projectIsPending = projectStatusId === ProjectStatusIdEnum.PENDING

  const userIsDb = user.getIn(['permissions', 'database'])
  const userIsCreateUser = createUserId === user.get('userId')

  // no one can edit deleted paths
  if (pathDataNew.deleted === true) {
    return false
  }

  // E-Band finalized paths are view-only. In Progress E-Band paths
  // inside projects remain fully editable.
  if (
    isEBandPath(pathDataNew.band) &&
    pathDataNew.pathStatusId === PathStatusIdEnum.FINALIZED
  ) {
    return false
  }

  return (
    // if we're not within project summary, then only DB users can edit path details.
    !withinProjectSummary && userIsDb ||
    // if we are within project summary,
    // the user can edit if...
    withinProjectSummary && (
      // the project is In Progress and user is the create user of this path.
      projectIsInProgress && userIsCreateUser ||
      // or the project is Pending and the user is a DB user.
      projectIsPending && userIsDb
    )
  )
}

export default canUserEditPathDetails
